@if (inProgress) {
<mat-progress-bar mode="indeterminate" color="primary" class="progress-bar" />
}
<header mat-dialog-title>
  <mat-icon class="dialog-icon">{{ data.dialogIcon }}</mat-icon>
  @for ( entityName of firstTwoEntityNames; track entityName; let index =
  $index; let first = $first) { @if (!first) {
  {{
    first ? '' : index === data.selectedEntityNames.length - 1 ? ' and ' : ', '
  }}
  }{{ entityName }}
  } @if (remainingEntityCount > 0) { and
  {{ remainingEntityCount }} other@if (remainingEntityCount !== 1) {
  <span>s</span>
  } }
</header>

<mat-dialog-content>
  <app-information-box>
    <p>
      You have selected
      {{
        data.selectedEntityNames.length === 1
          ? (data.definiteArticle ? 'the ' : '') + data.singularEntityType
          : (data.definiteArticle ? 'the ' : '') +
            (remainingExpanded ? data.selectedEntityNames.length + ' ' : '') +
            data.pluralEntityType +
            ':'
      }}
      @if (!remainingExpanded) { @for ( entityName of firstTwoEntityNames; track
      entityName; let index = $index; let first = $first) { @if (!first) {
      {{
        first
          ? ''
          : index === data.selectedEntityNames.length - 1
          ? ' and '
          : ', '
      }}
      }
      {{ entityName }}
      } @if (remainingEntityCount > 0) { and @if (!remainingExpanded) {
      <a (click)="remainingExpanded = true" class="others-link">
        {{ remainingEntityCount }} other@if (remainingEntityCount !== 1) {
        <span>s</span>
        }
        <mat-icon>expand_more</mat-icon>
      </a>
      } } } @if (remainingExpanded) {
      <a (click)="remainingExpanded = false">
        <mat-icon>expand_less</mat-icon>
      </a>
      }
    </p>
    @if (remainingExpanded) {
    <ul>
      @for (entityName of data.selectedEntityNames; track entityName) {
      <li>
        {{ entityName }}
      </li>
      }
    </ul>
    } @if (data.infoBoxText) {
    <p>{{ data.infoBoxText }}</p>
    }
  </app-information-box>
  <p>{{ data.confirmationText }}</p>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
  <button mat-button (click)="closeDialog(false)" [disabled]="inProgress">
    CANCEL
  </button>
  <button
    mat-raised-button
    [color]="data.negativeAction ? 'warn' : 'primary'"
    (click)="closeDialog(true)"
    [disabled]="inProgress"
  >
    {{ data.confirmationButtonText | uppercase }}
  </button>
</mat-dialog-actions>
